<template>

    <div class="social-carousel">
        
		<TitleHeader :subtitle="subtitle" :title="title"></TitleHeader>
		
        <div class="social-container">
            
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" :key="slide.id" v-for="slide in socialItems">
                        <div class="social-card">
                            <img class="social-card-img" :src="slide.photo" :alt="slide.alt" />
                            <div class="tags">
                                <img class="social-card-icon" :src="slide.icon" :alt="slide.iconAlt" />
                                <span class="handle">{{ slide.handle }}</span>
                            </div>
                            <div class="caption">{{ slide.caption }}</div>
                            <div class="social-card-link">
                                <PrimaryCTA v-if="slide.cta.linkText" :linkText="slide.cta.linkText" :linkURL="slide.cta.linkURL"></PrimaryCTA>
                            </div>
                        </div>
                    </div>
                </div>
				
				<div class="swiper-button-prev">
					<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8" xml:space="preserve" class="icon-arrow-right"><path d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z"></path></svg>
				</div>
				<div class="swiper-button-next">
					<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8" xml:space="preserve" class="icon-arrow-right"><path d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z"></path></svg>
				</div>
				
                <div class="swiper-pagination"></div>
            </div>
        </div>
    </div>
	
</template>

<script>

    import TitleHeader from '../Global/TitleHeader.vue';
    import PrimaryCTA from '../Global/PrimaryCTA.vue';
	
	export default {
		name: 'SocialCarousel',
		
		props: ['subtitle', 'title', 'socialItems'],
		
		components: {
            TitleHeader,
            PrimaryCTA,
		}
	}
	
</script>